










import {
  QuestionObjective,
  QuestionSubjective,
} from '@/resource/question/question.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import QuestionDetail from './QuestionDetail.vue';
import QuestionDifficulty from './QuestionDifficulty.vue';

@Component({
  components: { QuestionDetail, QuestionDifficulty },
})
export default class QuestionInfo extends Vue {
  @Prop({ required: true })
  question: QuestionObjective | QuestionSubjective;

  @Prop({ default: false })
  isHideSubjectName: boolean;
}
